import { VBadge } from 'vuetify/lib/components/VBadge';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center"},[_c(VBadge,{attrs:{"color":"info","dark":"","overlap":"","bottom":"","content":_vm.count}},[_c('sn-card',{attrs:{"show":_vm.show,"kind":_vm.topCard(_vm.deck),"width":50}})],1)],1),_c('div',{staticClass:"text-center font-weight-black"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }